import { createSlice } from "@reduxjs/toolkit";
import { format, startOfMonth, endOfMonth } from "date-fns";

// Período padrão da coluna Queima de caixa: mês atual, igual à Análise
// Tributária (redux/taxAnalises.js).
export const currentMonthQueimaPeriod = () => {
  const today = new Date();
  return {
    issue_date_start: format(startOfMonth(today), "yyyy-MM-dd"),
    issue_date_end: format(endOfMonth(today), "yyyy-MM-dd"),
  };
};

const initialState = () => ({
  params: {
    page: 1,
    limit: 15,
  },
  search: {},
  columns: [],
  queimaPeriod: currentMonthQueimaPeriod(),
});

export const relatorioProdutosNovoSlice = createSlice({
  name: "relatorioProdutosNovo",
  initialState,
  reducers: {
    handleParams: (state, { payload }) => {
      state.params[payload?.field] = payload?.value;
    },
    // Troca a busca inteira e volta para a primeira página.
    handleSetSearch: (state, { payload }) => {
      state.search = payload || {};
      state.params.page = 1;
    },
    handleSetColumns: (state, { payload }) => {
      state.columns = payload;
    },
    // Só troca `omit`, preservando `position` (ver RelatorioProdutosNovo/helpers/tributeGroups.js).
    handleToggleColumnsOmit: (state, { payload }) => {
      const omitById = {};
      payload.forEach(col => {
        omitById[col.id] = col.omit;
      });
      state.columns = state.columns.map(col =>
        col.id in omitById ? { ...col, omit: omitById[col.id] } : col,
      );
    },
    handleQueimaPeriod: (state, { payload }) => {
      state.queimaPeriod = payload;
    },
  },
});

export const {
  handleParams,
  handleSetSearch,
  handleSetColumns,
  handleToggleColumnsOmit,
  handleQueimaPeriod,
} = relatorioProdutosNovoSlice.actions;

export default relatorioProdutosNovoSlice.reducer;
